/**
 * StartEditingIcon Component
 * Icon for "Start editing" action (e.g. open in create-video).
 */

import React from 'react';
import type { IconProps } from './types';
import { colors } from '../colors';

const defaultColor = colors.neutral[400];

const StartEditingIcon: React.FC<IconProps> = ({
  size = 20,
  color = defaultColor,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.167 14.167l1.666-1.667-1.666-1.667 1.666 1.667h-5"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.333 8.333V12.5c0 4.167-1.666 5.833-5.833 5.833h-5c-4.167 0-5.833-1.666-5.833-5.833v-5c0-4.167 1.666-5.833 5.833-5.833h4.167"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.333 8.333H15c-2.5 0-3.333-.833-3.333-3.333V1.667l6.666 6.666z"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StartEditingIcon;
